import { withStyles } from "$components/mui-styles";
import {
  Box,
  AccordionDetails as MUIAccordionDetails,
} from "@material-ui/core";
import React, { useContext } from "react";
import { CardContext } from "./context";

// The expandable Card has no padding of its own, so the details own the
// responsive horizontal (and bottom) padding; the top gap comes from the
// wrapping Box below.
const AccordionDetails = withStyles((theme) => ({
  root: {
    display: "block",
    paddingTop: 0,
    paddingLeft: theme.spacing(1),
    paddingRight: theme.spacing(1),
    paddingBottom: theme.spacing(1),
    [theme.breakpoints.up("sm")]: {
      paddingLeft: theme.spacing(2),
      paddingRight: theme.spacing(2),
      paddingBottom: theme.spacing(2),
    },
  },
}))((props) => <MUIAccordionDetails {...props} />);

export interface CardDetailsProps {
  children: React.ReactNode;
}

const CardDetails = ({ children }: CardDetailsProps) => {
  const { expandable } = useContext(CardContext);

  return (
    <Box pt={1}>
      {expandable ? <AccordionDetails>{children}</AccordionDetails> : children}
    </Box>
  );
};

export default CardDetails;
